export default {
  name: 'MicrosoftMarketplaceSetupSubmitted',

  computed: {
    can_view_dashboard() {
      return false;
    },
  },

  methods: {
    go_to_login() {
      this.$router.push({ name: 'Login' });
    },

    go_to_dashboard() {
      this.$router.push({ path: '/home' });
    },
  },
};
